import VodItem from '@/features/VOD/vodClasses/vodItem'

export const parseAspectRatioToNumber = (
    item: VodItem,
    defaultAspectRatio = 2 / 3
) => {
    if (item.aspectRatio) {
        const parts = item.aspectRatio.split(':')
        const width = parseInt(parts[0])
        const height = parseInt(parts[1])
        if (width && height) {
            const numberRatio = width / height
            if (numberRatio) return numberRatio
        }
    }
    return defaultAspectRatio
}
